export function copyToClipboard(text) {
  try {
    if (!navigator.clipboard && window.clipboardData) {
      window.clipboardData.setData('Text', text);
      return true;
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error(err);
    return false;
  }
}

export function getUrlQueryParameter(key) {
  const urlParams = new URLSearchParams(location.search);
  return urlParams.get(key);
}
